import { partialRight } from 'ramda';
import { render } from 'react-dom';
export var domSink = partialRight(render, [document.getElementById('root')]);
export var redirectSink = function redirectSink(url) {
  if (!url) return;
  window.location = url;
};